import { createStore, withProps } from '@ngneat/elf';
import { withRequestsStatus } from '@ngneat/elf-requests';

import {SuppliersUnit} from '@store/suppliers/units';

export const suppliersUnitsDetailsStore = createStore(
  {name: 'supplier-units'},
  withProps<Partial<SuppliersUnit>>({}),
  withRequestsStatus(),
);
